import ExternalScreen from 'cordova-plugin-wkwebview-external-screen';
import { Capacitor } from '@capacitor/core';
import accountStore from '../stores/account';
import StrService from './str';
import { AndroidExternalScreen } from 'muvika-android-external-screen';

class ExternalViewCommands {

  loadBasicToIosExternalScreen() {
    ExternalScreen.checkAvailability(function (isAvailable) {
      if (isAvailable) {
        const exUrl = accountStore.getState().urls.url_ext_screen;
        const exUrlBasic = exUrl + "basic/";
        StrService.get(exUrlBasic, {})
          .then(function (res) {
            ExternalScreen.loadHTML(exUrl, res.data);
          });
      } else {
        ExternalScreen.checkOut();
      }
    });
  };

  loadBasicToAndroidExternalScreen() {
    AndroidExternalScreen.checkAvailability().then((res) => {
      if (res.value) {
        const exUrl = accountStore.getState().urls.url_ext_screen;
        console.log("externalUrl", exUrl)
        const exUrlBasic = exUrl + "basic/";
        StrService.get(exUrlBasic, {})
          .then(function (res) {
            AndroidExternalScreen.loadHTML({ baseUrl: exUrl, html: res.data });
          });
      } else {
      }
    });
  };

  invokeJSOnExternalView(js) {
    if (Capacitor.getPlatform() === 'ios') {
      ExternalScreen.checkAvailability(function (isAvailable) {
        if (isAvailable) {
          ExternalScreen.invokeJavaScript(js);
        }
      });
    }
    if (Capacitor.getPlatform() === 'android') {
      AndroidExternalScreen.checkAvailability().then((res) => {

        if (res.value) {
          AndroidExternalScreen.invokeJavaScript({ js: js });
        }
      });
    }
  }

  getCurrentTime(callback) {
    if (Capacitor.getPlatform() === 'ios') {
      ExternalScreen.getCurrentTime(function (currentTime) {
        callback(currentTime);
      });
    }
    if (Capacitor.getPlatform() === 'android') {
      AndroidExternalScreen.getCurrentTime().then((res) => {

        callback(res.value);
      });
    }
  }

}

export default new ExternalViewCommands();